import { get, post } from "../../../services/request";

export const getMasterHierarchyService = () => {
  return get("TenantHierarchyConfiguration/GetMasterHierarchy");
};

export const getTenantHierarchyConfigurationService = (tenantId) => {
  return get("TenantHierarchyConfiguration/GetTenantHierarchyConfiguration", {
    tenantId,
  });
};

export const saveTenantHierarchyConfigurationService = (payload) => {
  return post("TenantHierarchyConfiguration/SaveTenantHierarchyConfiguration", payload);
};

export const bulkUpdateTenantHierarchyAliasService = (payload) => {
  return post("TenantHierarchyConfiguration/BulkUpdateAlias", payload);
};
